var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head',{attrs:{"title":"Dashboard"}}),_vm._v(" "),_c('h1',{staticClass:"mb-8 text-3xl font-bold"},[_vm._v("Dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }